import React from 'react';
import {
  OfferedItemDetails,
  ProjectHomeIdentifiersProps,
} from './OfferedItemDetails';
import { OfferedItemLookup } from './useOfferedItemsDataSource';

type Props = ProjectHomeIdentifiersProps & {
  items: OfferedItemLookup[];
  stepId: string;
};

export const CategoryGroup: React.FC<Props> = (props) => {
  const { items, ...rest } = props;

  if (items.length === 0) {
    return null;
  }

  return (
    <div className="mb-2">
      {items.map((item) => (
        <OfferedItemDetails
          key={item.id}
          item={item}
          {...rest}
          className="mb-2"
        />
      ))}
    </div>
  );
};
